export default {
  create: 'Under construction',
  timeout: 'timeout',
  finish: 'finish',
  doing: ' Processing',
  errorafter: 'Replenishment',
  open: 'Open',
  close: 'Close',
  success: 'success',
  success1: 'Paid',
  success2: 'normal',
  success3: 'pass',
  success4: 'callback success',
  success5: 'paid success',
  success6: 'replenished success',

  paying: 'payment ongoing',
  doing1: 'Applying',
  doing2: 'processing',
  doing3: 'processing',
  doing88: 'Manual order',

  error: 'failed',
  error1: 'Unpaid',
  error2: 'Disable',
  error3: 'reject',
  error4: 'No callback',
  error5: 'callback failed',
  error6: 'Paid failed',
  error7: 'replenished  fail',
  error8: 'not yet replenished',
  error9: 'replenished for paid fail',
  error10: 'replenished for callback fail',
  error11: 'Invalid order',
  error12: 'Invalid order',
  error13: 'Locked',
  choose: 'Please select first',
  worring: 'This operation is risky, do you want to continue?',
  tip: 'tip',
  confor: 'Sure',
  Cancel: 'Cancel',
  batchSuccess: 'Batch order replenishment successful!',
  cancelOlder: 'Batch replenishment order has been taken'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/status.js